import { useSections } from '../../context/site-content.context';
import { createElementId } from '../../helpers/content.helper';
import { DocumentVariant } from '../../models/component.model';
import { ContentWrapper } from '../collections/ContentWrapper';
import { ImageContentDisplay } from '../images/ImageContentDisplay';
import { ContentHtml } from '../sections/ContentHtml';
import { LinkContentDisplay } from '../sections/LinkContentDisplay';

interface Props {
    before?: React.ReactNode;
    item: DocumentVariant;
    contentClassName?: string;
}

export const DocumentVariantDisplay = ({
    item,
    contentClassName,
    before,
}: Props): React.ReactElement<any, any> | null => {
    const sections = useSections(item.id);

    const contentClassNameInner = contentClassName
        ? contentClassName + ' document-variant-display'
        : 'document-variant-display';

    return (
        <>
            {sections.map((section, index) => {
                const id = createElementId(section.id);

                return (
                    <ContentWrapper id={id} key={id} contentClassName={contentClassNameInner}>
                        <div className="py-5 px-sm-5 px-4">
                            {index === 0 && before}
                            {section.header && (
                                <h2 className="display-5 mb-4 content-header">{section.header}</h2>
                            )}
                            <div>
                                {section.image && (
                                    <div className="float-right ml-5">
                                        <ImageContentDisplay image={section.image} />
                                    </div>
                                )}
                                {section.body && <ContentHtml source={section.body} />}
                            </div>
                            <div style={{ clear: 'both' }}></div>
                            <LinkContentDisplay link={section.link} />
                        </div>
                    </ContentWrapper>
                );
            })}
        </>
    );
};
